import React from 'react';

import classnames from 'classnames';

import { ButtonTypes } from '../Button/Button';
import StackingLayout from '../StackingLayout/StackingLayout';
import Link, { type LinkProps } from './Link';

import './LinkButton.scss';

export default function LinkButton({ type = ButtonTypes.SECONDARY, ...props }: React.PropsWithChildren<LinkProps>) {
  const classNames = classnames({
    'link-button': true,
    'link-button--disabled': props.disabled,
    [`link-button--${type}`]: type,
    [`${props.className}`]: props.className,
  });

  return (
    <StackingLayout className={classNames}>
      <Link className="link-button__text" underline={false} type={type} {...props}>
        {props.children}
      </Link>
    </StackingLayout>
  );
}
